import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class cohortsService extends ApiBaseService {
  constructor(private http: HttpClient) {
    super(http, '/cohorts');
  }

    // Custom delete method that includes program validation
    deleteWithProgramValidation(cohortId: number, programId: number): Observable<any> {
      return this.http.delete(`${environment.apiUrl}/cohorts/${cohortId}/validate-program/${programId}`);
    }
}
